import React, { useEffect, useState } from 'react'
import api from '../../API/api';
import Marquee from "react-fast-marquee";
import FiberSmartRecordIcon from '@mui/icons-material/FiberSmartRecord';

const Ticker = () => {


    const [notice, setNotice] = useState();

    useEffect(() => {
        getTicker();
    }, []);

    const getTicker = () => {
        api.getEventAndNotice().then((res) => {
            // console.log(res);
            setNotice(res.data.notice);
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    return (
        <>
            <div className='bg-dark p-0'>
                <div className="col-12">
                    {/* <div className='text-white'>
                        Admission Going On
                    </div> */}

                    <div className=' text-white'>

                        <ul>
                            <Marquee className='p-2 d-flex align-items-center' pauseOnHover={true} speed='70'>

                                <div>
                                    {notice ?
                                        <>
                                            {notice.map((n) =>
                                            (

                                                <span className='m-2'>
                                                    <a href={n.link? `${n.link}`: `${process.env.REACT_APP_BACKEND}assets/notice/${n.file}`} className='text-white' style={{ textDecoration: 'none' }}>
                                                        <FiberSmartRecordIcon />  {n.notice}
                                                    </a>
                                                </span>

                                            ))
                                            }
                                        </>
                                        :
                                        <span className='m-2'>
                                            <FiberSmartRecordIcon /> No Ticker News Available
                                        </span>
                                    }
                                </div>

                            </Marquee>





                            {/* {notice && notice.map((n) => {
                                <li>
                                    <div class="content">{n.notice}</div>
                                    <div class="snapper"></div>
                                </li>

                            })} */}


                        </ul>

                    </div>







                </div>

            </div>
        </>
    )
}

export default Ticker;